import axios from './index';

class CompaniesApi {
  static List = (data) => {
    console.log(data);
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      name: String(data.name),
      company_code: String(data.companyCode),
      email: String(data.email),
      phone_number: String(data.phoneNumber),
      country_code: String(data.countryCode),
      address_line1: String(data.addressLine1),
      address_line2: String(data.addressLine2),
      city: String(data.city),
      state: String(data.state),
      country: String(data.country),
      landmarks: String(data.landmarks),
      pincode: String(data.pincode),
      pan_number: String(data.panNumber),
      gst_number: String(data.gstNumber),
      status: String(data.status),
    };
    // console.log(`From Api ${request}`);
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      name: String(data.name),
      email: String(data.email),
      phone_number: String(data.phoneNumber),
      country_code: String(data.countryCode),
      address_line1: String(data.addressLine1),
      address_line2: String(data.addressLine2),
      city: String(data.city),
      state: String(data.state),
      country: String(data.country),
      landmarks: String(data.landmarks),
      pincode: String(data.pincode),
      pan_number: String(data.panNumber),
      gst_number: String(data.gstNumber),
      status: String(data.status),
    };
    return axios.put(`${base}/${data.id}`, request);
  };

  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };

  //   static Delete = (data) => {
  //     return axios.delete(`${base}/${data.id}`);
  //   };
}

let base = 'dashboard/company';

export default CompaniesApi;
